/**
 * Selection helpers for entity list pages (bulk actions vs client-side filters).
 *
 * `selectedIds` can retain rows hidden by search/status filters when "select all"
 * accumulates across filter changes. Bulk labels and operations must use only the
 * intersection with the current filtered rows.
 */

export function getEntityListRowId(row) {
  return row?._id;
}

/**
 * @param {Set<unknown>|Iterable<unknown>|null|undefined} selectedIds
 * @param {unknown[]|null|undefined} rows
 * @param {(row: unknown) => unknown} [getId]
 * @returns {Set<unknown>}
 */
export function intersectSelectedIdsWithRows(selectedIds, rows, getId = getEntityListRowId) {
  const selected =
    selectedIds instanceof Set
      ? selectedIds
      : selectedIds
        ? new Set(selectedIds)
        : new Set();
  if (selected.size === 0) return new Set();
  const next = new Set();
  for (const row of rows || []) {
    const id = getId(row);
    if (id != null && id !== "" && selected.has(id)) next.add(id);
  }
  return next;
}

/**
 * @param {Set<unknown>|Iterable<unknown>|null|undefined} selectedIds
 * @param {unknown[]|null|undefined} rows
 * @param {(row: unknown) => unknown} [getId]
 * @returns {number}
 */
export function countSelectedAmongRows(selectedIds, rows, getId = getEntityListRowId) {
  return intersectSelectedIdsWithRows(selectedIds, rows, getId).size;
}

/**
 * @param {number} count
 * @returns {string} e.g. ` (12)` or ``
 */
export function formatSelectedCountSuffix(count) {
  const n = Number(count);
  return Number.isFinite(n) && n > 0 ? ` (${n})` : "";
}
